/* import __COLOCATED_TEMPLATE__ from './email-verification-banners.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import templateOnlyComponent from '@ember/component/template-only';

export interface Args {
  isEmailAttributeNotProtected: boolean;
  hasCustomDomains: boolean;
}

interface Signature {
  Args: Args;
}

const EmailVerificationBanners = templateOnlyComponent<Signature>();

export default EmailVerificationBanners;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::Builder::Body::Sections::Request::EmailVerificationBanners': typeof EmailVerificationBanners;
    'workflow-connector/builder/body/sections/request/email-verification-banners': typeof EmailVerificationBanners;
  }
}
